import React, { useEffect, useState } from "react";
import sampleProducts from "./sampleProducts";
import ProductModal from "./ProductModal";
import sampleModalConfig from "./sampleModalConfig";
import AppNavBar from "../common/AppNavBar";
import "./ProductModal.css";
const categories = [
  "All",
  "Wardrobe",
  "Kitchen Base",
  "Kitchen Wall",
  "Loft",
  "Other",
  "Wardrobe F&S",
  "Carcass Only",
  "Panel",
];

const CatalogPage = () => {
  const [search, setSearch] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalProduct, setModalProduct] = useState(null);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [brokenImages, setBrokenImages] = useState([]); // Track broken images

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const filteredProducts = sampleProducts.filter((product) => {
    const matchesCategory =
      selectedCategory === "All" || product.category === selectedCategory;
    const searchLower = search.toLowerCase();
    const matchesSearch =
      product.name.toLowerCase().includes(searchLower) ||
      product.sku.toLowerCase().includes(searchLower);
    const isImageOk = !brokenImages.includes(product.sku);
    return matchesCategory && matchesSearch && isImageOk;
  });

  const openModal = (product) => {
    setModalProduct(product);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalProduct(null);
  };

  const handleImageError = (sku) => {
    setBrokenImages((prev) => [...prev, sku]);
  };

  return (
    <>
      <AppNavBar />

      <div className="container mt-5 pt-3">
        <div className="row justify-content-center">
          <div className="col-12 col-md-11 col-lg-10 mt-4">
            <h2 className="mb-4 text-center fw-bold">Catalog</h2>

            {/* Search Bar */}
            <div className="row mb-4">
              <div className="col-12">
                <div className="position-relative">
                  <i
                    className="fa fa-search position-absolute top-50 start-0 translate-middle-y ps-2 text-muted"
                    style={{ pointerEvents: "none" }}
                  ></i>
                  <input
                    type="text"
                    className="form-control form-control-sm ps-4"
                    placeholder="Search by name or SKU..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* Scrollable Category Pills */}
            <div className="row mb-4">
              <div className="col-12">
                <div
                  className="d-flex gap-2 overflow-auto"
                  style={{
                    whiteSpace: "nowrap",
                    paddingBottom: "4px",
                  }}
                >
                  {categories.map((cat) => {
                    const isActive = selectedCategory === cat;
                    const isHovered = hoveredCategory === cat;
                    return (
                      <button
                        key={cat}
                        className={`btn btn-sm px-3 py-1 ${
                          isActive || isHovered
                            ? "btn-dark text-white"
                            : "btn-outline-dark"
                        }`}
                        onClick={() => setSelectedCategory(cat)}
                        onMouseEnter={() => setHoveredCategory(cat)}
                        onMouseLeave={() => setHoveredCategory(null)}
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {cat}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Product List */}
            <div className="row g-4">
              {filteredProducts.map((product) => (
                <div
                  className="col-6 col-md-4"
                  key={product.sku}
                  onClick={() => openModal(product)}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className="card border shadow-sm d-flex flex-column"
                    style={{ height: "400px" }}
                  >
                    <div
                      className="d-flex align-items-center justify-content-center flex-grow-1 w-100 p-2"
                      style={{ height: "85%" }}
                    >
                      <img
                        src={product.image}
                        alt={product.name}
                        className="img-fluid"
                        style={{ objectFit: "contain", height: `${40 + (product.default_height / 2100)*60}%` }}
                        onError={() => handleImageError(product.sku)}
                      />
                    </div>
                    <div className="card-body bg-white d-flex justify-content-between align-items-center border-top p-2 w-100">
                      <small>{product.name}</small>
                      <small className="text-muted">({product.sku})</small>
                    </div>
                  </div>
                </div>
              ))}
              {filteredProducts.length === 0 && (
                <div className="text-center w-100">No products found.</div>
              )}
            </div>
          </div>
        </div>
      </div>

      <ProductModal
        open={modalOpen}
        onClose={closeModal}
        product={modalProduct}
        config={sampleModalConfig}
      />
    </>
  );
};

export default CatalogPage;
